// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

export const version = '5.4.2'
export const publishDates = {
	major: '2026-05-06T16:28:18.473Z',
	minor: '2026-09-02T11:04:02.901Z',
	patch: '2026-09-10T12:05:42.789Z',
}
